import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-left",
  templateUrl: "./med-icon-arrow-left.component.html",
})
export class MedIconArrowLeftComponent extends SvgMixinComponent {}
